import { render, staticRenderFns } from "./screeningIntroduction.vue?vue&type=template&id=8fac73a2&scoped=true&"
import script from "./screeningIntroduction.vue?vue&type=script&lang=js&"
export * from "./screeningIntroduction.vue?vue&type=script&lang=js&"
import style0 from "./screeningIntroduction.vue?vue&type=style&index=0&id=8fac73a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fac73a2",
  null
  
)

export default component.exports